module.exports = __webpack_public_path__ + "static/media/deezer-rond..f2ff68a1.png";